import { useState } from "react";

import LoadingOverlay from "Components/common/loading/LoadingOverlay";
import ModalCloseButton from "../common/ModalCloseButton";
import ModalButton from "../common/ModalButton";
import ModalDecorations from "./ModalDecorations";
import AuthRedirectText from "./AuthRedirectText";
import AgreementCheckbox from "./AgreementCheckbox";
import ModalDialog from "../common/ModalDialog";
import ModalContent from "../common/ModalContent";
import ModalHeader from "../common/ModalHeader";
import ModalTitle from "../common/ModalTitle";
import ModalBody from "../common/ModalBody";
import ModalFooter from "../common/ModalFooter";
import SignupLogo from "./SignupLogo";

import { ELEMENT_IDS } from "constants/constants";

export default function SignUpModalWrapper({
    modalType,
    setSignUpOptions,
    setErrors,
    handleCloseModal,
    loading,
    handleRegisterPress,
    isTyped,
    children,
}) {
    const [agreement, setAgreement] = useState(false);
    const signUpModalCloseId = "signUp-modal-close";
    const handleClose = () => {
        setSignUpOptions(false);
        setErrors([]);
        handleCloseModal();
    }
    return (
        <ModalDialog className="md:tw-max-w-[700px] sm:tw-mt-24 sm:pt-0">
            <SignupLogo
                variant={modalType === "signUpAsBrand" ? "brand" : "creator"}
                showDesktop
                extraClass={
                    modalType === "signUpAsBrand"
                        ? "brand-signup-inside-logo"
                        : "creator-signup-inside-logo"
                }
            />

            <ModalContent>
                <LoadingOverlay loading={loading} />
                <ModalHeader className="sm:tw-pt-[50px] tw-border-none">
                    <ModalTitle text={modalType === "signUpAsBrand" ? "Brand sign up" : "Creator sign up"} />

                    <ModalCloseButton
                        id={signUpModalCloseId}
                        onClose={() => {
                            handleClose();
                        }}
                    />
                </ModalHeader>

                <ModalBody className="sm:tw-flex-col">
                    <ModalDecorations />
                    {children}
                </ModalBody>

                <ModalFooter>
                    <AgreementCheckbox className="sm:tw-mt-3 sm:tw-mb-3" onChange={(val) => {
                        setAgreement(val)
                    }} onClickLink={() => {
                        document.getElementById(signUpModalCloseId)?.click();
                        handleClose()
                    }} />
                    <AuthRedirectText
                        // className="tw-block sm:tw-hidden"
                        question="Already have an account?"
                        actionText="Login"
                        onAction={() => {
                            document.getElementById(signUpModalCloseId)?.click();
                            handleClose();
                            // open login 
                            document.getElementById(ELEMENT_IDS.BTN_LOG_IN_FROM_LP)?.click();
                        }}
                    />
                    <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full tw-mb-6">
                        {/* <p className="tw-hidden sm:tw-block">* fields are required</p> */}
                        <ModalButton
                            label="Sign Up"
                            onClick={() => handleRegisterPress(modalType)}
                            loading={loading}
                            disabled={!isTyped || !agreement}
                        />
                    </div>
                </ModalFooter>
            </ModalContent>
        </ModalDialog>
    );
}
